<template>
  <div class="lower-page member-information">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('confirm_login_information') }}</h2>
    </div>

    <section class="wrapper">
      <p class="intro">{{ $t('member_info_header') }}</p>
      <form v-if="myAccount">
        <div class="entry-detail-wrapper">
          <dl class="entry-detail-item input-form">
            <dt>{{ $t('plan_id') }}<span class="hiss">＊</span></dt>
            <dd class="about-plan">
              <input type="text" readonly disabled :value="planName">
              <a @click="showModal('about-plan')">{{ $t('label_about-plan') }}</a>
            </dd>
            <dt class="hr">{{ $t('name') }}<span class="hiss">＊</span></dt>
            <dd><input type="text" name="name" id="name" placeholder="山田太郎" v-model="$v.myAccount.memberinfo.fullname.$model" :state="validateState('fullname')">
              <b-form-invalid-feedback :state="validateState('fullname')">
                <p v-if="!$v.myAccount.memberinfo.fullname.required">{{ $t('is required').replace('%s', $t('name')) }}</p>
                <p v-if="!$v.myAccount.memberinfo.fullname.maxLength">{{ $t('less than').replace('%s', $t('name').toLowerCase()).replace('%d', '30') }}</p>
                <p v-if="!$v.myAccount.memberinfo.fullname.minLength">{{ $t('more than').replace('%s', $t('name').toLowerCase()).replace('%d', $v.myAccount.memberinfo.fullname.$params.minLength.min) }}</p>
              </b-form-invalid-feedback></dd>
            <dt v-show="activeLanguage === 'ja'">フリガナ</dt>
            <dd v-show="activeLanguage === 'ja'">
              <input type="text" name="name_kana" id="name_kana" placeholder="ヤマダタロウ" v-model="$v.myAccount.memberinfo.fullname_furigana.$model">
              <b-form-invalid-feedback :state="validateState('fullname_furigana')">
                <p v-if="!$v.myAccount.memberinfo.fullname_furigana.maxLength">30文字以下で入力してください</p>
                <p v-if="!$v.myAccount.memberinfo.fullname_furigana.minLength">フリガナ{{$v.myAccount.memberinfo.fullname_furigana.$params.minLength.min}}文字以上入力してください</p>
              </b-form-invalid-feedback></dd>
            <dt class="l2">{{ $t('email_address') }}<span class="hiss">＊</span><br><span class="fontS" v-show="activeLanguage !== 'name_zh-tw' && activeLanguage !== 'name_zh-cn'">{{ $t('member_id') }}</span></dt>
            <dd>
              <input type="text" placeholder="glocaly@example.com" v-model="$v.myAccount.email_address.$model" :state="validateEmail()">
              <b-form-invalid-feedback :state="validateEmail()">
                <p v-if="!$v.myAccount.email_address.required">{{ $t('is required').replace('%s', $t('email_address')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="l2">{{ $t('password_for_login') }}<span class="hiss">＊</span><br><span class="fontS">{{ $t('for_login') }}</span></dt>
            <dd>
              <input :type="passwordShowHide" name="pw" id="pw" placeholder="*********" v-model="$v.myAccount.password.$model" :state="validatePassword()">
              <span class="field-icon" @click="showPassword = !showPassword">
                <img src="@/assets/img/client/mdi-eye-off.png" alt="" width="33" height="21" v-if="showPassword">
                <img src="@/assets/img/client/mdi-eye.png" alt="" width="33" height="21" v-else>
              </span>
              <b-form-invalid-feedback :state="validatePassword()">
                <p v-if="!$v.myAccount.password.required">{{ $t('is required').replace('%s', $t('password_for_login').toLowerCase()) }}</p>
                <p v-if="!$v.myAccount.password.minLength">{{ $t('more than').replace('%s', $t('password_for_login').toLowerCase()).replace('%d', $v.myAccount.password.$params.minLength.min) }}</p>
              </b-form-invalid-feedback></dd>
            <dt class="hr">{{ $t( 'country' )}}<span class="hiss">＊</span></dt>
            <dd>
              <select name="countries" id="countries" v-model="$v.myAccount.memberinfo.country.$model" class="w-100" :state="validateState('country')" @change="changeCountry">
                <option value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(country, index) in countries" :key="index" :value="country">{{ country }}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('country')">
                <p v-if="!$v.myAccount.memberinfo.country.required">{{ $t('is required').replace('%s', $t('country')) }}</p>
              </b-form-invalid-feedback></dd>
            <dt>{{ $t('postal_code') }}<span class="hiss">＊</span></dt>
            <dd><input type="text" name="zip" id="zip" placeholder="000-0000" class="inputS" v-model="$v.myAccount.memberinfo.postal_code.$model" :state="validateState('postal_code')">
              <b-form-invalid-feedback :state="validateState('postal_code')">
                <p v-if="!$v.myAccount.memberinfo.postal_code.required">{{ $t('is required').replace('%s', $t('postal_code')) }}</p>
              </b-form-invalid-feedback></dd>
            <dt v-show="activeLanguage === 'ja'">都道府県</dt>
            <dd v-show="activeLanguage === 'ja'">
              <select name="prefectures" id="prefectures" v-model="myAccount.memberinfo.prefectures" :disabled="myAccount.memberinfo.country !== 'Japan'">
                <option :value="null" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(prefecture, index) in countriesPrefectures" :key="index" :value="prefecture">{{prefecture}}</option>
              </select>
            </dd>
            <dt>{{ $t('Address') }}<span class="hiss">＊</span></dt>
            <dd><input type="text" name="add" id="add" :placeholder="$t('address-placeholder')" v-model="$v.myAccount.memberinfo.address.$model">
              <b-form-invalid-feedback :state="validateState('address')">
                <p v-if="!$v.myAccount.memberinfo.address.maxLength">{{ $t('less than').replace('%s', $t('name').toLowerCase()).replace('%d', '80') }}</p>
                <p v-if="!$v.myAccount.memberinfo.address.required">{{ $t('is required').replace('%s', $t('Address')) }}</p>
              </b-form-invalid-feedback></dd>
            <dt class="hr">{{ $t('phone_number') }}</dt>
            <dd><input type="tel" name="tel" id="tel" placeholder="00-0000-0000" class="inputS" v-model="myAccount.memberinfo.phone_number"></dd>
            <dt>{{ $t('fax_number') }}</dt>
            <dd><input type="tel" name="fax" id="fax" placeholder="00-0000-0000" class="inputS" v-model="myAccount.memberinfo.fax_number"></dd>
            <dt class="hr">{{ $t('age') }}<span class="hiss">＊</span></dt>
            <dd>
              <select name="age" id="age" v-model="myAccount.memberinfo.age">
                <option value="" disabled selected>{{ $t(['please_choose']) }}</option>
                <option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('age')">
                <p v-if="!$v.myAccount.memberinfo.age.required">{{ $t('is required').replace('%s', $t('age')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('sex') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="radio" name="sex" id="Male" value="Male" v-model="myAccount.memberinfo.gender"><label for="Male" class="radioTxt">{{ $t('male') }}</label>
              <input type="radio" name="sex" id="Female" value="Female" v-model="myAccount.memberinfo.gender"><label for="Female" class="radioTxt">{{ $t('female') }}</label>
            </dd>
            <dt class="hr">{{ $t('company_name') }}</dt>
            <dd>
              <input type="text" v-model="myAccount.memberinfo.company_name" :placeholder="$t('company_name-placeholder')">
            </dd>
            <dt class="company_detail">
              {{ $t('company_detail') }}
              <div v-html="$t('company_detail_caution1')"></div>
            </dt>
            <dd>
              <textarea v-model="myAccount.memberinfo.company_description" :placeholder="$t('company_detail-placeholder')" rows="5"></textarea>
              <div v-html="$t('company_detail_caution2')"></div>
            </dd>
          </dl>
          <dl class="entry-detail-item input-form">
            <dt>{{ $t('business_type')  }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="checkbox" id="business_type_indivisual" v-model="$v.myAccount.memberinfo.business_type_indivisual.$model">
              <label for="business_type_indivisual" class="checkbox">{{ $t('business_type_indivisual') }}</label>
              <input type="checkbox" id="business_type_developer" v-model="$v.myAccount.memberinfo.business_type_developer.$model">
              <label for="business_type_developer" class="checkbox">{{ $t('business_type_developer') }}</label>
              <input type="checkbox" id="business_type_mediator" v-model="$v.myAccount.memberinfo.business_type_mediator.$model">
              <label for="business_type_mediator" class="checkbox">{{ $t('business_type_mediator') }}</label>
              <b-form-invalid-feedback :state="validateState('business_type_developer')">
                <p v-if="!$v.myAccount.memberinfo.business_type_developer.businessTypeValidation">{{ $t('is required').replace('%s', $t('business_type')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('area') }}<span class="hiss">＊</span></dt>
            <dd>
              <select name="area" id="area" v-model="$v.myAccount.memberinfo.area.$model">
                <option :value="null" disabled>{{ $t(['please_choose']) }}</option>
                <option v-for="(prefecture, index) in prefectures" :key="index" :value="prefecture">{{ $t(index) }}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('area')">
                <p v-if="!$v.myAccount.memberinfo.area.required">{{ $t('is required').replace('%s', $t('area')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt>{{ $t('area_detail')  }}</dt>
            <dd>
              <textarea v-model="myAccount.memberinfo.area_detail" :placeholder="$t('area_detail-placeholder')" rows="5"></textarea>
            </dd>
            <dt>{{ $t('property_use') }}<span class="hiss">＊</span></dt>
            <dd>
              <span v-for="(item, index) in propertyUses" :key="item">
                <input v-model="myAccount.memberinfo.use_of_the_property" @change="resetSelect" type="radio" name="use" class="useSelect" :id="`property-use-${index}`" :value="item"><label :for="`property-use-${index}`" class="radioTxt">{{$t(item)}}</label>
              </span>
            </dd>
            <dt>{{ $t('property_type_under_consideration') }}<span class="hiss">＊</span></dt>
            <dd>
              <div>
                <select name="type" v-model="$v.myAccount.memberinfo.types_of_properties.$model">
                  <option :value="null" disabled selected>{{ $t('please_choose') }}</option>
                  <option v-for="item in propertyType" :key="item" :value="item">{{$t(item)}}</option>
                </select>
              </div>
              <b-form-invalid-feedback :state="validateState('types_of_properties')">
                <p v-if="!$v.myAccount.memberinfo.types_of_properties.required">{{ $t('is required').replace('%s', $t('property_type_under_consideration')) }}</p>
              </b-form-invalid-feedback></dd>
            <dt>{{ $t('preferred_range') }}<span class="hiss">＊</span></dt>
            <dd>
              <select name="price_range" id="price_range" v-model="myAccount.memberinfo.desired_price_range">
                <option value="null" disabled selected>{{ $t('please_choose') }}</option>
                <option v-for="item in price" :key="item" :value="item">{{$t(item)}}</option>
              </select>
              <b-form-invalid-feedback :state="validateState('desired_price_range')">
                <p v-if="!$v.myAccount.memberinfo.desired_price_range.required">{{ $t('is required').replace('%s', $t('preferred_range')) }}</p>
              </b-form-invalid-feedback>
            </dd>
            <dt class="hr">{{ $t('email_distribution') }}<span class="hiss">＊</span></dt>
            <dd>
              <input type="radio" name="newsletter" id="ok" value="ok" v-model="myAccount.memberinfo.email_magazine_delivery"><label for="ok" class="radioTxt">{{ $t('want') }}</label>
              <input type="radio" name="newsletter" id="ng" value="ng" v-model="myAccount.memberinfo.email_magazine_delivery"><label for="ng" class="radioTxt">{{ $t('dont_want') }}</label>
            </dd>
          </dl>
        </div>
        <div class="submit" v-bind:class="{ unfinished: isSubscribed() }">
          <a type="button" class="brown_btn" @click="accountUpdate"><span>{{ $t('update') }}</span></a>
          <div v-show="status" class="py-3 px-5 my-4">
            <p class="m-0">{{ status }}</p>
          </div>
          <p v-on:click="!isSubscribed() && showModal('withdrawal')"><span id="withdrawalBtn">{{ $t('withdrawal_application') }}</span></p>
          <p class="attention" v-html="$t('html_withdrawal-caution')" />
        </div>
      </form>
    </section>

    <footerClient />
    <modal name="withdrawal" height="auto" :reset="true">
      <div class="modal-header">
        <h2>{{ $t('withdrawal') }}</h2>
      </div>
      <div class="modal-body">
        <p class="caution">{{ $t('withdrawal_content') }}</p>
        <div class="buttons">
          <button class="withdrawalBtn" @click="withdrawal">{{$t('withdrawal')}}</button>
          <button class="brown_btn" @click="hideModal('withdrawal')"><span>{{ $t('cancel') }}</span></button>
        </div>
      </div>
    </modal>
    <modal name="about-plan" height="auto" :reset="true">
      <div class="modal-header">
        <h2>{{ $t('label_about-plan') }}</h2>
      </div>
      <div class="modal-body">
        <div v-html="$t('html_about-plan')"></div>
        <button class="white_btn" @click="hideModal('about-plan')">{{ $t('label_close') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import { mapState, mapActions } from 'vuex'
import Vue from 'vue'
import { memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../../assets/data/values'

const businessTypeValidation = (_value, vm) => {
  return vm.business_type_developer || vm.business_type_mediator || vm.business_type_indivisual
}

export default {
  data () {
    return {
      currentlanguage: Vue.$cookies.get('language'),
      disabled: true,
      show: true,
      showPassword: true,
      residentialList: businessPropertyValues.propertyTypes.residential,
      investmentList: businessPropertyValues.propertyTypes.investment,
      propertyUses: propertyUses,
      price: propertyPrices,
      newPassword: null,
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      },
      status: null,
      ageSetup: memberAges
    }
  },
  validations: {
    myAccount: {
      memberinfo: {
        fullname: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(30)
        },
        fullname_furigana: {
          minLength: minLength(2),
          maxLength: maxLength(30)
        },
        country: { required },
        address: {
          required,
          maxLength: maxLength(80)
        },
        age: { required },
        postal_code: { required },
        gender: { required },
        use_of_the_property: { required },
        desired_price_range: { required },
        types_of_properties: { required },
        email_magazine_delivery: { required },
        area: { required },
        business_type_developer: { businessTypeValidation },
        business_type_mediator: { businessTypeValidation },
        business_type_indivisual: { businessTypeValidation }
      },
      email_address: { required },
      password: { minLength: minLength(8) }
    }
  },
  components: {
    navbar,
    footerClient
  },
  computed: {
    ...mapState(['language']),
    ...mapState('login', ['myAccount']),
    ...mapState('adminAddMember', ['countries', 'prefectures']),
    countriesPrefectures () {
      switch (this.selectedCountry) {
        case 'japan':
          return this.prefectures
        case 'other':
          return this.countries
        default:
          return this.prefectures
      }
    },
    propertyType () {
      if (this.myAccount.memberinfo.use_of_the_property === 'Residential use') {
        return this.residentialList
      }
      return this.investmentList
    },
    activeLanguage () {
      if (!this.language && !this.currentlanguage) {
        return 'name_ja'
      } else {
        if (!this.language) {
          return this.currentlanguage
        }
        return this.language
      }
    },
    passwordShowHide () {
      return this.showPassword ? 'password' : 'text'
    },
    planName () {
      return this.myAccount.plan === '無料プラン' ? this.$t('label_free-plan') : this.myAccount.plan
    }
  },
  created () {
    this.myAccountAccount()
    this.prefectureCountryClient()
  },
  methods: {
    ...mapActions('login', ['myAccountAccount', 'clientUpdate', 'withdrawalClient']),
    ...mapActions('adminAddMember', ['prefectureCountryClient']),
    validateState (name) {
      const { $dirty, $error } = this.$v.myAccount.memberinfo[name]
      return $dirty ? !$error : null
    },
    resetSelect: function () {
      this.myAccount.memberinfo.types_of_properties = null
    },
    validateEmail () {
      const { $dirty, $error } = this.$v.myAccount.email_address
      return $dirty ? !$error : null
    },
    validatePassword () {
      const { $dirty, $error } = this.$v.myAccount.password
      return $dirty ? !$error : null
    },
    accountUpdate: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = this.$t('label_form-error')
      } else {
        this.clientUpdate(this.myAccount)
        this.$nextTick(() => {
          this.$v.$reset()
        })
        this.status = null
      }
    },
    withdrawal: function () {
      const id = { id: this.myAccount.id }
      this.withdrawalClient(id)
    },
    changeCountry () {
      if (this.myAccount.memberinfo.country !== 'Japan') {
        this.myAccount.memberinfo.prefectures = null
      }
    },
    showModal (name) {
      this.$modal.show(name)
    },
    hideModal (name) {
      this.$modal.hide(name)
    },
    isSubscribed () {
      return this.myAccount.plan !== '無料プラン'
    }
  }
}
</script>

<style scoped>
.member-information .about-plan input{
  height: auto;
  background-color: #D5D5D5;
  width: auto;
}
.member-information .about-plan a{
  font-weight: bold;
  margin-left: 40px;
  position: relative;
  padding-left: 40px;
  top: -10px;
}
.member-information .about-plan a::before{
  content: '?';
  color: #fff;
  font-weight: bold;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  position: absolute;
  margin: auto;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: #000;
  text-align: center;
  line-height: 32px;
}
.member-information .entry-detail-wrapper .entry-detail-item .company_detail{
  flex-wrap: wrap;
  align-content: center;
  padding-right: 40px;
}
.member-information .entry-detail-wrapper .entry-detail-item .company_detail div{
  color: #BC9B5D;
  font-size: .875em;
  margin-top: 1em;
}
.member-information .company_detail + dd div{
  color: #EA6031;
  font-size: .875em;
  margin-top: 1em;
  text-indent: -1em;
  padding-left: 1em;
}
.member-information .sub_info{
  max-width: 700px;
  background: #F2F2F2;
  margin: 1.5em auto 0;
  text-align: center;
  font-weight: bold;
  padding: 1em;
}
.member-information .caution{
  color: #EA6031;
  font-weight: bold;
}
.member-information .withdrawalBtn{
  margin: 0 40px;
}
.member-information .submit{
  align-items: stretch;
  flex-wrap: wrap;
  max-width: 700px;
}
.member-information .submit .brown_btn{
  width: 100%;
  max-width: none;
  margin-bottom: 24px;
}
.member-information .submit #withdrawalBtn{
  color: #707070;
  border: 1px solid #707070;
  padding: 1em;
  width: 160px;
  text-align: center;
  display: block;
}
.member-information .submit p span{
  text-decoration: none;
}
.member-information .submit .attention{
  background: #FEF2EF;
  color: #EA6031;
  font-size: .875em;
  width: calc(100% - 176px);
  text-align: left;
  align-items: center;
  justify-content: center;
  padding: .5em .5em .5em 1.5em;
  text-indent: -1em;
  display: none;
}
.member-information .submit.unfinished #withdrawalBtn{
  opacity: .4;
  cursor: default;
}
.member-information .submit.unfinished .attention{
  display: flex;
}
@media screen and (max-width: 768px){
  .member-information .intro{
    text-align: left;
  }
  .member-information .about-plan a{
    display: block;
    margin: 1em 0 0;
    top: 0;
  }
  .member-information .entry-detail-wrapper .entry-detail-item .company_detail{
    display: block;
    line-height: 1.5;
    padding-right: 0;
  }
  .member-information .entry-detail-wrapper .entry-detail-item .company_detail div{
    margin: .5em 0;
  }
  .member-information .company_detail + dd div{
    margin-top: .5em;
  }
  .member-information .sub_info{
    margin-top: 0;
  }
  .member-information .entry-detail-wrapper .entry-detail-item dt{
    margin: 0;
    padding: 0;
    line-height: 1.5;
  }
  .member-information .entry-detail-wrapper .entry-detail-item dt.hr{
    padding-top: 8px;
  }
  .member-information .entry-detail-wrapper .entry-detail-item dd{
    margin-bottom: 16px !important;
  }
  .member-information .withdrawalBtn{
    margin: 0 24px;
    white-space: nowrap;
  }
}
@media screen and (max-width: 460px){
  .member-information .submit .attention{
    width: 100%;
    margin-top: .5em;
  }
}
</style>

<style>
.member-information .vm--modal{
  max-width: 960px;
}

.member-information .modal-body h3{
  font-size: 1.25em;
  margin-top: 40px;
  font-weight: bold;
}

.member-information .modal-body a{
  font-weight: bold;
  color: #BC9B5D;
  text-decoration: underline;
  margin-top: 1em;
  display: block;
}

.member-information .modal-body a:hover{
  text-decoration: none;
}

.member-information .modal-body h3 + p{
  margin-top: 1em;
}
</style>
